// extracted by mini-css-extract-plugin
export default {"box2":"statistics_box2__zGA2G","icon":"statistics_icon__iI7+u","name":"statistics_name__6gg-q"};